import React, { Component } from 'react';
import L from "leaflet";
import axios from 'axios';
import "leaflet/dist/leaflet.css";
import { kml } from '@mapbox/leaflet-omnivore';
import TextField from '@material-ui/core/TextField';
import debounce from 'lodash.debounce';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Icon from '@material-ui/core/Icon';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import { Search, Error } from '@material-ui/icons/';
import swal from 'sweetalert';

// Avoid first 2 messages
let avoid = 0;
let antena = L.icon({
    iconUrl: './images/antena.png',
    iconSize: [30, 30]
});
let meicon = L.icon({
    iconUrl: './images/me2.png',
    // iconSize: [23, 30]
    iconSize: [139, 139]
});
let myIcon = L.icon({
    iconUrl: './images/marker.png',
    iconSize: [40, 40]
});
// let myIcon2 = L.icon({
//     iconUrl: './images/marker2.png',
//     iconSize: [40, 40]
// });
let nc = L.icon({
    iconUrl: './images/noConst.png',
    iconSize: [40, 40]
});
let cIcon = L.icon({
    iconUrl: './images/marker5.png',
    iconSize: [40, 40]
});
class Mapa extends Component {

    constructor(props) {
        super(props);
        this.remove_map_layer = this.remove_map_layer.bind(this);
        // this.autocomplete = this.autocomplete.bind(this);
        this.getCoordinates = this.getCoordinates.bind(this);

        this.onChange = this.onChange.bind(this);
        this.onChangeNodo = this.onChangeNodo.bind(this);
        this.delayedCallback = debounce(this.autocomplete, 500);
        this.handleChange = this.handleChange.bind(this);
        this.sendXDM = this.sendXDM.bind(this);
        this.mapClick = this.mapClick.bind(this);
        this.polyClick = this.polyClick.bind(this);
        this.toggleSearchBox = this.toggleSearchBox.bind(this);
        this.searchNodo = this.searchNodo.bind(this);
        this.searchPoste = this.searchPoste.bind(this);
        this.changePoste = this.changePoste.bind(this);
        this.changeNodo = this.changeNodo.bind(this);
        this.searchCoordinates = this.searchCoordinates.bind(this);
        this.searchCoordenadas = this.searchCoordenadas.bind(this);

        this.state = {
            options: null,
            departamento: "",
            municipio: "",
            zona: "",
            showSearchBox: false,
            nodo: '',
            poste: '',
            lat: '',
            lon: '',
            search: '',
            latB: '',
            lonB: '',
            loading: 0,
            searching: 0
        }
    }

    //Did mount########################################################################
    componentDidMount() {
        //Main layers
        this.map1 = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            edgeBufferTiles: 5
        });

        this.map2 = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
            maxZoom: 18,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            edgeBufferTiles: 5
        });
        this.map3 = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            maxZoom: 18,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            edgeBufferTiles: 5
        });

        this.map4 = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
            maxZoom: 18,
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            edgeBufferTiles: 5
        });

        // create map
        this.map = L.map('map', {
            center: [this.props.latC, this.props.lonC],
            zoom: 19,
            zoomControl: false
        });
        // Add the controls to the map
        L.control.zoom({
            position: 'bottomright'
        }).addTo(this.map);
        //Click del map
        let t = this;
        this.map.on('click', function (e) {
            t.mapClick(e);
        });
        //Add the open street map to the map
        this.map1.addTo(this.map);

        // Where am I marker
        this.marker = L.marker([this.props.latC, this.props.lonC], { icon: meicon }).addTo(this.map);
        this.searchCoordinates(this.props.latC, this.props.lonC, 3);

        this.markerC = L.marker([this.props.latC, this.props.lonC], { icon: cIcon });

        this.noConstruidas = L.featureGroup();
        this.lte = L.featureGroup();
        this.ftth = L.featureGroup();
        this.antenas = L.featureGroup();
        this.sMarker = L.marker([this.props.latC, this.props.lonC], { icon: meicon }).bindPopup("");

    }

    isFloat(num) {
        let n = parseFloat(num);
        if (isNaN(n)) return false;

        return (n % 1 !== 0);
    }
    // When we click the search on the coordinates modal
    searchCoordenadas() {

        if (!this.isFloat(this.state.latB) || !this.isFloat(this.state.lonB)) {
            swal({
                title: "Coordenadas Inválidas",
                text: "",
                icon: "error",
                button: "OK",
            });
        } else if (this.state.latB !== "" && this.state.lonB !== "") {
            this.searchCoordinates(this.state.latB, this.state.lonB, 1);
        } else {
            swal({
                title: "Las coordenadas no pueden venir vacías",
                text: "",
                icon: "error",
                button: "OK",
            });
        }
    }

    // We search by current user coordinates
    searchCoordinates(lat, lon, op, nodo) {
        let t_ = this;
        this.setState({ loading: 1 });
        axios.post(t_.props.url + "../polygon/pointInPolygon/",
            {
                lat: lat,
                lon: lon,
                nodo: nodo
            }
        )
            .then(function (data) {
                data = data.data;
                // let msg = data.replace(/(<([^>]+)>)/ig, "");
                let msg = data;
                if (avoid === 1) {
                    if (typeof window.parent.sendCopy === 'function') {
                        window.parent.sendCopy(msg);
                    } else {
                        console.log(msg);
                    }
                }

                let dat = data.split("#####");
                msg = dat[0].split(",");

                let nd = [msg[0]];
                if (dat.length > 1) {
                    nd.push(dat[1].split(",")[0]);
                }

                let sTipo = "SI";
                if (msg[2] !== "NC" && msg[6] !== "NC") {
                    if (msg[6] === "LTE") {
                        // t_.props.toggleLTE(1);
                        t_.props.addNodo(nd);
                    }
                    if (msg[6] === "RA") {
                        t_.props.toggleAdquirida(1);
                        t_.props.addNodo(nd);
                    }
                    if (msg[6] === "TS") {
                        t_.props.addNodo(nd);
                    }
                    if (msg[6] === "FTTH") {
                        t_.props.addNodo(nd);
                    }
                    t_.props.updateSearch(lat, lon, msg[1], msg[0], sTipo);
                } else {
                    sTipo = "NC";
                    if (msg[6] === "NC") {
                        t_.props.addNodo(msg[0]);
                    }
                    t_.props.updateSearch(lat, lon, "<div class='rojo'>No hay Cobertura</div>", t_.state.poste, sTipo);
                }
                t_.setState({ options: null, nodo: '', poste: '', search: '', loading: 0 });
                if (op === 1) {
                    t_.props.toggleSearchCoordenadas();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    //Check when enter on search poste
    changePoste(e) {
        // console.log(e.keyCode);
        if (e.keyCode === 13) {
            this.searchPoste();
        }
    }

    //Check when enter on search nodo
    changeNodo(e) {
        // console.log(e.keyCode);
        if (e.keyCode === 13) {
            this.searchNodo();
        }
    }

    //Toggle SearchBox
    toggleSearchBox() {
        this.setState({ showSearchBox: !this.state.showSearchBox })
    }
    //When we click on the map
    mapClick(e) {
        this.cLat = e.latlng.lat;
        this.cLon = e.latlng.lng;
        this.markerC.setLatLng([e.latlng.lat, e.latlng.lng]).addTo(this.map);
        this.props.changeFCoordinates(e.latlng.lat, e.latlng.lng, true);
        this.sendXDM();
    }

    //When we click on the polygons
    polyClick(e) {
        this.cLat = e.latlng.lat;
        this.cLon = e.latlng.lng;
        this.props.changeFCoordinates(e.latlng.lat, e.latlng.lng, false);
        this.sendXDM();
    }
    // Remove Map layers
    remove_map_layer() {
        if (this.map.hasLayer(this.map1)) this.map.removeLayer(this.map1);
        if (this.map.hasLayer(this.map2)) this.map.removeLayer(this.map2);
        if (this.map.hasLayer(this.map3)) this.map.removeLayer(this.map3);
        if (this.map.hasLayer(this.map4)) this.map.removeLayer(this.map4);
    }

    // handle change of the select
    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    //Autocomplete
    autocomplete(e) {
        // this.setState({ search: e.target.value });
        // let search = this.search.current.value;
        let search = e.target.value;
        if (search.length > 3) {
            this.setState({ loading: 1, searching: 1 });
            let t_ = this;
            axios.post(t_.props.url + "autocompletar",
                {
                    term: search,
                    departamento: this.state.departamento,
                    municipio: this.state.municipio,
                    zona: this.state.zona,
                }
            )
                .then(function (data) {
                    t_.setState({ options: data.data, loading: 0 })
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
    onChange(event) {
        event.persist();
        this.delayedCallback(event);
    }

    onChangeNodo = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    // Search the poste value
    searchPoste() {
        if (this.state.poste !== "") {
            // this.getCoordinates(this.state.poste, 3);
            // this.getCoordinates(this.state.nodo, 2);
            let t_ = this;
            this.setState({ loading: 1 });
            axios.post(t_.props.url + "poste",
                {
                    poste: this.state.poste
                }
            )
                .then(function (data) {
                    if (data.data !== "") {
                        let lat = data.data.lat;
                        let lon = data.data.lon;
                        axios.post(t_.props.url + "../polygon/pointInPolygon/",
                            {
                                lat: lat,
                                lon: lon
                            }
                        )
                            .then(function (data) {
                                data = data.data;
                                // let msg = data.replace(/(<([^>]+)>)/ig, "");
                                let msg = data;
                                if (typeof window.parent.sendCopy === 'function') {
                                    window.parent.sendCopy(msg);
                                } else {
                                    console.log(msg);
                                }

                                let dat = data.split("#####");
                                msg = dat[0].split(",");

                                let nd = [msg[0]];
                                if (dat.length > 1) {
                                    nd.push(dat[1].split(",")[0]);
                                }

                                let sTipo = "SI";
                                if (msg[2] !== "NC" && msg[6] !== "NC") {
                                    if (msg[6] === "LTE") {
                                        // t_.props.toggleLTE(1);
                                        t_.props.addNodo(nd);
                                    }
                                    if (msg[6] === "RA") {
                                        t_.props.toggleAdquirida(1);
                                        t_.props.addNodo(nd);
                                    }
                                    if (msg[6] === "TS") {
                                        t_.props.addNodo(nd);
                                    }
                                    if (msg[6] === "FTTH") {
                                        t_.props.addNodo(nd);
                                    }
                                    t_.props.updateSearch(lat, lon, msg[1], msg[0], sTipo);
                                } else {
                                    sTipo = "NC";
                                    if (msg[6] === "NC") {
                                        t_.props.addNodo(msg[0]);
                                    }
                                    t_.props.updateSearch(lat, lon, "<div class='rojo'>No hay Cobertura</div>", t_.state.poste, sTipo);
                                }
                                t_.setState({ options: null, nodo: '', poste: '', search: '', loading: 0 });
                                t_.props.toggleSearchPoste();
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    } else {
                        t_.setState({ options: null, nodo: '', poste: '', search: '' });
                        t_.props.toggleSearchPoste();
                        swal({
                            title: "El poste no existe en la BD",
                            text: "",
                            icon: "error",
                            button: "OK",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

    // Search the nodo value
    searchNodo() {
        if (this.state.nodo !== "") {
            this.getCoordinates(this.state.nodo, 2);
        } else {
            swal({
                title: "Debe de seleccionar un nodo",
                text: "",
                icon: "error",
                button: "OK",
            });
        }
    }
    //We get the coordinates
    getCoordinates(value, op) {
        let t_ = this;
        this.setState({ loading: 1 });
        let nodo = value;
        axios.post(t_.props.url + "search",
            {
                id: value,
                op: op
            }
        )
            .then(function (data) {
                if (data.data.length > 0) {
                    data = data.data;
                    // update the search parameters
                    // t_.props.updateSearch(data[0].lat, data[0].lon, data[0].observaciones, data[0].nodo);
                    t_.setState({ options: null, nodo: '', poste: '', search: '', showSearchBox: false, loading: 0, searching: 0 });
                    if (op === 2) {
                        let i = Math.floor(data.length / 2);
                        t_.searchCoordinates(data[i].lat, data[i].lon, 0, nodo);
                    } else {
                        t_.searchCoordinates(data[0].lat, data[0].lon, 0);
                    }
                }

                if (op === 1) {
                    // Close the modal
                    t_.props.toggleSearch();
                    // t_.props.addNodo(data[0].nodo);
                } else if (op === 2) {
                    // Close the modal
                    t_.props.toggleSearchNodo();
                } else if (op === 3) {
                    // Close the modal
                    t_.props.toggleSearchPoste();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    componentDidUpdate(prevProps) {
        // If my current position changes
        if (this.props.latC !== prevProps.latC || this.props.lonC !== prevProps.lonC) {
            this.searchCoordinates(this.props.latC, this.props.lonC, 3);
            // this.map.panTo([this.props.latC, this.props.lonC]);
            // this.marker.setLatLng([this.props.latC, this.props.lonC]);
        }

        //Load the polygons for lte
        if (this.props.lte !== null && this.props.antenas !== null && this.props.noConsruidas !== null && this.props.region_polygons !== null && this.props.dataLoaded !== 2) {
            // Agregamos los poligonos de la capa no construidos
            let noConstruidas = this.props.noConstruidas;
            let ncArray = [];
            let t = this;
            for (let i = 0; i < noConstruidas.length; i++) {
                if (typeof noConstruidas[i].coordenadas !== 'undefined') {
                    let text = '<h3 class="title-mapa">' + noConstruidas[i].nombre + '</h3>' + noConstruidas[i].descripcion;
                    let poly = L.polygon(noConstruidas[i].coordenadas, { color: noConstruidas[i].color })
                        .bindPopup(text.replace(/"/g, ""));
                    // let t = this;
                    poly.on('click', function (e) {
                        t.polyClick(e);
                    });
                    ncArray.push([
                        poly,
                        noConstruidas[i].nombre
                    ]);
                }
            }
            // this.noConstruidas = L.featureGroup(ncArray);
            // this.noConstruidas.addTo(this.map);
            this.noConstruidas = ncArray;

            //We load the LTE polygons
            let lte = this.props.lte;
            let lteArray = [];
            for (let i = 0; i < lte.length; i++) {
                if (typeof lte[i].coordenadas !== 'undefined') {
                    let text = '<h3 class="title-mapa">' + lte[i].nombre + '</h3>' + lte[i].descripcion;
                    let poly = L.polygon(lte[i].coordenadas, { color: '#00567c', fillColor: '#00567c', fillOpacity: 0.5 })
                        .bindPopup(text.replace(/"/g, ""));
                    // let t = this;
                    poly.on('click', function (e) {
                        t.polyClick(e);
                    });
                    lteArray.push(poly);
                }
            }
            this.lte = L.featureGroup(lteArray);

            //We load the LTE polygons
            let ftth = this.props.ftth;
            let ftthArray = [];
            if (typeof ftth !== 'undefined') {
                for (let i = 0; i < ftth.length; i++) {
                    if (typeof ftth[i].coordenadas !== 'undefined') {
                        let text = '<h3 class="title-mapa">' + ftth[i].nombre + '</h3>' + ftth[i].descripcion;
                        let poly = L.polygon(ftth[i].coordenadas, { color: '#d69d00', fillColor: '#d69d00', fillOpacity: 0.5 })
                            .bindPopup(text.replace(/"/g, ""));
                        // let t = this;
                        poly.on('click', function (e) {
                            t.polyClick(e);
                        });
                        ftthArray.push(poly);
                    }
                }
            }
            this.ftth = L.featureGroup(ftthArray);

            // We load the LTE markers
            let antenas = this.props.antenas;
            let antenasArray = [];
            for (let i = 0; i < antenas.length; i++) {
                if (typeof antenas[i].coordenadas !== 'undefined') {
                    let text = '<h3 class="title-mapa">' + antenas[i].nombre + '</h3>' + antenas[i].descripcion;
                    antenasArray.push(L.marker(antenas[i].coordenadas, { icon: antena }).bindPopup(text.replace(/"/g, "")));
                }
            }
            this.antenas = L.featureGroup(antenasArray);

            //we update the data loaded flag
            this.props.updateLoaded();

            let myCustomGroup = L.geoJSON(null, {
                style: {
                    color: '#41c800',
                    fillColor: '#41c800',
                    fillOpacity: 0.5
                }
            });

            let a = new Date();
            let r = a.getDate();
            r = r + "" + a.getMonth() + "" + a.getHours() + "" + a.getMinutes();

            this.adquirida = kml(this.props.url + '../_kml/adquirida.kml?v=' + r, null, myCustomGroup);

            //We load the Cobertura polygons
            let region_polygons = this.props.region_polygons;
            let cobertura = [];
            for (let i = 0; i < region_polygons.length; i++) {
                if (typeof region_polygons[i].coordenadas !== 'undefined') {
                    // Bouble text
                    let text = '<h3 class="title-mapa">' + region_polygons[i].nombre + '</h3>' + region_polygons[i].descripcion;
                    // let poly = L.polygon(region_polygons[i].coordenadas, { color: "#0055ff", fillColor: "#000", fillOpacity: 0.5 }).bindPopup(text.replace(/"/g, ""));

                    let poly;
                    if (region_polygons[i].tipo === "0") {
                        poly = L.polygon(region_polygons[i].coordenadas, { color: "#0055ff", fillColor: "#000", fillOpacity: 0.5 }).bindPopup(text.replace(/"/g, ""));
                    } else if (region_polygons[i].tipo === "1") {
                        poly = L.polygon(region_polygons[i].coordenadas, { color: "#41c800", fillColor: "#41c800", fillOpacity: 0.5 }).bindPopup(text.replace(/"/g, ""));
                    } else if (region_polygons[i].tipo === "2") {
                        poly = L.polygon(region_polygons[i].coordenadas, { color: "#00567c", fillColor: "#00567c", fillOpacity: 0.5 }).bindPopup(text.replace(/"/g, ""));
                    } else {
                        poly = L.polygon(region_polygons[i].coordenadas, { color: '#d69d00', fillColor: '#ffbe00', fillOpacity: 0.5 }).bindPopup(text.replace(/"/g, ""));
                    }

                    // let t = this;
                    poly.on('click', function (e) {
                        t.polyClick(e);
                    });
                    cobertura.push([
                        poly,
                        region_polygons[i].region,
                        region_polygons[i].municipio,
                        region_polygons[i].zona,
                        region_polygons[i].nombre,
                        region_polygons[i].tipo
                    ]);
                }
            }
            this.cobertura = cobertura;
        }

        //Toggle LTE
        if (this.props.showLTE) {
            this.lte.addTo(this.map);
            this.antenas.addTo(this.map);
        } else {
            this.map.removeLayer(this.lte);
            this.map.removeLayer(this.antenas);
        }

        //Toggle FTTH
        if (this.props.showFTTH) {
            this.ftth.addTo(this.map);
        } else {
            this.map.removeLayer(this.ftth);
        }

        //Toggle Adquirida
        if (typeof this.adquirida !== "undefined") {
            if (this.props.showAdquirida) {
                this.adquirida.addTo(this.map);
            } else {
                this.map.removeLayer(this.adquirida);
            }
        }

        // Switch to change the map types
        if (prevProps.mapType !== this.props.mapType) {
            this.remove_map_layer();
            switch (this.props.mapType) {
                case 1:
                    this.map1.addTo(this.map);
                    break;
                case 2:
                    this.map2.addTo(this.map);
                    break;
                case 3:
                    this.map3.addTo(this.map);
                    break;
                case 4:
                    this.map4.addTo(this.map);
                    break;
                default:
                    break;
            }
        }

        /************************************************************************
         * Switch the HFC polygons on an off
         ************************************************************************/
        if (typeof this.cobertura !== "undefined" && this.cobertura) {

            let arrBounds = [];
            for (let i = 0; i < this.cobertura.length; i++) {
                if (this.cobertura[i]) {
                    if (
                        (
                            this.props.regions_array.indexOf(this.cobertura[i][1]) >= 0 &&
                            (this.props.municipios_array.length === 0 || this.props.municipios_array.indexOf(this.cobertura[i][2]) >= 0) &&
                            (this.props.zonas_array.length === 0 || this.props.zonas_array.indexOf(this.cobertura[i][3]) >= 0)
                        ) ||
                        (
                            this.props.nodo_array.indexOf(this.cobertura[i][4]) >= 0
                        ) ||
                        (
                            this.props.showHFC
                        )
                    ) {
                        // Si esta activado mostrar HFC y el poligono es de tipo HFC
                        if (
                            this.props.showHFC && this.cobertura[i][5] === "0"
                        ) {
                            // console.log(this.cobertura[i], i);
                            if (!this.map.hasLayer(this.cobertura[i][0])) {
                                this.cobertura[i][0].addTo(this.map);
                            }
                            arrBounds.push(this.cobertura[i][0].getBounds());
                            // Si no esta show HFC
                        } else if (!this.props.showHFC) {
                            if (!this.map.hasLayer(this.cobertura[i][0])) {
                                this.cobertura[i][0].addTo(this.map);
                            }
                            arrBounds.push(this.cobertura[i][0].getBounds());
                        }

                        // Esto es para las otras capas
                        // Si el nodo esta en cualquier otra capa agregarlo
                        if (this.props.nodo_array.indexOf(this.cobertura[i][4]) >= 0) {
                            if (!this.map.hasLayer(this.cobertura[i][0])) {
                                this.cobertura[i][0].addTo(this.map);
                            }
                            arrBounds.push(this.cobertura[i][0].getBounds());
                            // Esto es para las otras capas
                            // Si el nodo esta en cualquier otra capa agregarlo
                        }

                    } else {
                        if (this.map.hasLayer(this.cobertura[i][0])) this.map.removeLayer(this.cobertura[i][0]);
                    }
                }
            }
            if (arrBounds.length > 0 && this.props.zoom) {
                this.map.fitBounds(arrBounds);
            }
        }
        // }

        /************************************************************************
         * Switch the No cobertura polygons on an off
         ************************************************************************/
        if (typeof this.noConstruidas !== "undefined" && this.noConstruidas) {
            for (let i = 0; i < this.noConstruidas.length; i++) {
                if (this.props.nodo_array.indexOf(this.noConstruidas[i][1]) >= 0 ||
                    this.props.showHFC
                ) {
                    if (!this.map.hasLayer(this.noConstruidas[i][0])) {
                        this.noConstruidas[i][0].addTo(this.map);
                    }
                } else {
                    if (this.map.hasLayer(this.noConstruidas[i][0]))
                        this.map.removeLayer(this.noConstruidas[i][0]);
                }
            }
        }

        if (prevProps.latC !== this.props.latC || prevProps.lonC !== this.props.lonC || (prevProps.sNodo !== this.props.sNodo && this.props.sNodo === "Me")) {
            this.searchCoordinates(this.props.latC, this.props.lonC, 3);
            this.marker.setLatLng([this.props.latC, this.props.lonC]);
            this.map.flyTo([this.props.latC, this.props.lonC], 18);
        }

        // Update the search marker
        if (prevProps.sLat !== this.props.sLat || prevProps.sLon !== this.props.sLon || prevProps.sObservaciones !== this.props.sObservaciones || prevProps.sNodo !== this.props.sNodo) {

            // Update the coordinates
            this.sMarker.setLatLng([this.props.sLat, this.props.sLon]);

            //Check the response to display the icon and text
            // if (this.props.sObservaciones !== null && this.props.sObservaciones.indexOf("PENDIENTE") >= 0) {
            //     // update the icon
            //     this.sMarker.setIcon(myIcon2);
            //     // update the popup content
            //     this.sMarker._popup.setContent("<h3 class='title-mapa'>" + this.props.sNodo + "</h3>" + this.props.sObservaciones).openPopup();
            if (this.props.sTipo === "NC") {
                // if (this.props.sTipo === "NC") {
                // update the icon
                this.sMarker.setIcon(nc);
                // update the popup content
                this.sMarker._popup.setContent("<h3 class='title-mapa'>" + this.props.sNodo + "</h3>" + this.props.sObservaciones);
                this.sMarker.openPopup();
            } else if (this.props.sTipo === "ME") {
                this.sMarker.setIcon(meicon);
                // this.searchCoordinates(this.props.latC, this.props.lonC, 3);
            } else {
                // update the icon
                this.sMarker.setIcon(myIcon);
                // update the popup content
                this.sMarker._popup.setContent("<h3 class='title-mapa'>" + this.props.sNodo + "</h3>" + this.props.sObservaciones.replace(/"/g, ""));
                this.sMarker.openPopup();
            }
            if (this.props.sTipo !== "ME") {
                this.sMarker.addTo(this.map);
                this.map.flyTo([this.props.sLat, this.props.sLon], 18);
            }
        }

    }

    compare(a, b) {
        if (parseInt(a.zona, 10) < parseInt(b.zona, 10)) {
            return -1;
        } else if (parseInt(a.zona, 10) > parseInt(b.zona, 10)) {
            return 1;
        } else {
            return 0;
        }
    }

    //Enviar el mensaje por xdm
    sendXDM() {
        let lat = this.props.fLat;
        let lon = this.props.fLon;
        let icon = this.props.fIcon;
        if (lat !== '' && lon !== '') {
            let t_ = this;
            axios.post(t_.props.url + "../polygon/pointInPolygon/",
                {
                    lat: lat,
                    lon: lon
                }
            )
                .then(function (data) {
                    data = data.data;
                    // let msg = data.replace(/(<([^>]+)>)/ig, "");
                    let msg = data;
                    if (typeof window.parent.sendCopy === 'function') {
                        window.parent.sendCopy(msg);
                    } else {
                        console.log(msg);
                    }

                    // msg = data.replace(/(<([^>]+)>)/ig, "").split(",");

                    if (icon) {
                        let dat = data.split("#####");
                        msg = dat[0].split(",");

                        let nd = [msg[0]];
                        if (dat.length > 1) {
                            nd.push(dat[1].split(",")[0]);
                        }

                        let sTipo = "SI";
                        if (msg[2] !== "NC" && msg[6] !== "NC") {
                            if (msg[6] === "LTE") {
                                // t_.props.toggleLTE(1);
                                t_.props.addNodo(nd);
                            }
                            if (msg[6] === "RA") {
                                t_.props.toggleAdquirida(1);
                                t_.props.addNodo(nd);
                            }
                            if (msg[6] === "TS") {
                                t_.props.addNodo(nd);
                            }
                            if (msg[6] === "FTTH") {
                                t_.props.addNodo(nd);
                            }
                            t_.props.updateSearch(lat, lon, msg[1], msg[0], sTipo);
                        } else {
                            sTipo = "NC";
                            if (msg[6] === "NC") {
                                t_.props.addNodo(msg[0]);
                            }
                            t_.props.updateSearch(lat, lon, "<div class='rojo'>No hay Cobertura</div>", t_.state.poste, sTipo);
                        }
                        t_.setState({ options: null, nodo: '', poste: '', search: '', loading: 0 });
                    }


                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

    //Render########################################################################
    render() {

        let loading = "";
        if (this.state.loading === 1) {
            loading = (
                <div className="loading-search">
                    <img src="images/loadingSearch.gif" alt="" />
                </div>
            );
        }

        let options = "";

        if (this.state.options) {
            options = this.state.options.map(x => <li onClick={() => this.getCoordinates(x.value, 1)} key={x.value}> {x.label}</li>);
        }

        let deptos = [];
        let r = this.props.regions;
        if (r) {
            let d = "";
            for (let i = 0; i < r.length; i++) {
                if (d !== r[i].region.trim()) {
                    deptos.push(<option key={i}>{r[i].region}</option>);
                    d = r[i].region.trim();
                }
            }
        }
        let munis = [];
        if (this.state.departamento !== "") {
            let m = "";
            for (let i = 0; i < r.length; i++) {
                if (r[i].municipio !== null) {
                    if (this.state.departamento === r[i].region && m !== r[i].municipio.trim()) {
                        munis.push(<option key={i}>{r[i].municipio}</option>);
                        m = r[i].municipio.trim();
                    }
                }
            }
        }
        let zonas = [];
        if (this.state.municipio !== "") {
            let z = "";
            let regs = [...r];
            regs.sort(this.compare);
            for (let i = 0; i < r.length; i++) {
                if (regs[i].zona !== null) {
                    if (this.state.departamento === regs[i].region && this.state.municipio === regs[i].municipio && z !== regs[i].zona.trim()) {
                        zonas.push(<option key={i}>{regs[i].zona}</option>);
                        z = regs[i].zona.trim();
                    }
                }
            }
        }

        //Do we show the search box
        let showSearchBox = '';
        let showFilters = 'active';
        if (this.state.showSearchBox) {
            showSearchBox = 'active';
            showFilters = '';
        }

        // No encontrado
        let noEncontrado = "";
        if (!this.state.options && !this.state.loading && this.state.searching) {
            noEncontrado = (
                <div className="not-found">
                    <Error /> No Existe Cobertura
                </div>
            );
        }

        //Search content
        let search = "";
        if (this.props.showSearch) {
            search = (
                <div className="search-modal" onClick={() => {
                    this.props.toggleSearch(); this.setState({ showSearchBox: false, searching: 0 });
                }}>
                    <div className="search-container" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <div className={`filters ${showFilters}`}>
                            <h2>
                                <img src="images/delimitar.png" alt="Delimitar" />
                                <span className="filter-title">
                                    Delimitar búsqueda
                                </span>
                            </h2>
                            <FormControl className="row">
                                <InputLabel htmlFor="departamento-native">Departamento</InputLabel>
                                <Select
                                    native
                                    value={this.state.departamento}
                                    onChange={this.handleChange('departamento')}
                                    inputProps={{
                                        name: 'departamento',
                                        id: 'departamento-native',
                                    }}
                                >
                                    <option value="" />
                                    {deptos}
                                </Select>
                            </FormControl>


                            <FormControl className="row">
                                <InputLabel htmlFor="municipio-native">Municipio</InputLabel>
                                <Select
                                    native
                                    value={this.state.municipio}
                                    onChange={this.handleChange('municipio')}
                                    inputProps={{
                                        name: 'municipio',
                                        id: 'municipio-native',
                                    }}
                                >
                                    <option value="" />
                                    {munis}
                                </Select>
                            </FormControl>


                            <FormControl className="row">
                                <InputLabel htmlFor="zona-native">Zona</InputLabel>
                                <Select
                                    native
                                    value={this.state.zona}
                                    onChange={this.handleChange('zona')}
                                    inputProps={{
                                        name: 'zona',
                                        id: 'zona-native',
                                    }}
                                >
                                    <option value="" />
                                    {zonas}
                                </Select>
                            </FormControl>
                            <div className="search-filter-buttons">
                                <Button className="cancel" onClick={this.props.toggleSearch}>
                                    CANCELAR
                                </Button>
                                <Button variant="contained" color="primary" className="search-btn" onClick={this.toggleSearchBox}>
                                    BUSCAR
                                </Button>
                            </div>
                        </div>
                        <div className={`search ${showSearchBox}`}>
                            <Icon className="icon"><Search /></Icon>
                            <TextField
                                id="search"
                                name="search"
                                label="Buscar"
                                onChange={this.onChange}
                                autoComplete="off"
                                autoFocus
                            />

                            <ul className="listado">
                                {
                                    options
                                }
                            </ul>
                        </div>
                    </div>
                </div >
            );
        }

        let searchNodo = "";

        if (this.props.showSearchBoxNodo) {
            searchNodo = (
                <div className="search-modal" onClick={this.props.toggleSearchNodo}>
                    <div className="search-container" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <div className={`search-nodo`}>
                            <Icon className="icon"><Search /></Icon>
                            <select
                                id="nodo"
                                name="nodo"
                                label="Buscar por Nodo"
                                value={this.state.nodo}
                                onChange={this.handleChange('nodo')}
                                autoFocus
                            >
                                <option value="">
                                    Seleccione un Nodo
                                </option>
                                {this.props.nodos && this.props.nodos.length > 0
                                    ? this.props.nodos.map(key => (
                                        <option key={key.nodo}>
                                            {key.nodo}
                                        </option>
                                    ))
                                    : ""}
                            </select>
                            <Button className="go" onClick={this.searchNodo}>
                                IR
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        let searchCoordinates = "";

        if (this.props.showSearchBoxCoordenadas) {
            searchCoordinates = (
                <div className="search-modal" onClick={this.props.toggleSearchCoordenadas}>
                    <div className="search-container" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <div className={`search-coordenadas`}>
                            <Icon className="icon"><Search /></Icon>
                            <TextField
                                id="latB"
                                name="latB"
                                label="Latitud"
                                value={this.state.latB}
                                onChange={this.handleChange('latB')}
                                onKeyDown={(event) => this.changeNodo(event)}
                                autoFocus
                            />
                            <TextField
                                id="lonB"
                                name="lonB"
                                label="Longitud"
                                value={this.state.lonB}
                                onChange={this.handleChange('lonB')}
                                onKeyDown={(event) => this.changeNodo(event)}
                            />
                            <Button className="go" onClick={this.searchCoordenadas}>
                                IR
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        let searchPoste = "";

        if (this.props.showSearchBoxPoste) {
            searchPoste = (
                <div className="search-modal" onClick={this.props.toggleSearchPoste}>
                    <div className="search-container" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <div className={`search-nodo`}>
                            <Icon className="icon"><Search /></Icon>
                            <TextField
                                id="poste"
                                name="poste"
                                label="Buscar por Poste"
                                value={this.state.poste}
                                onChange={this.handleChange('poste')}
                                onKeyDown={(event) => this.changePoste(event)}
                                autoFocus
                            />
                            <Button className="go" onClick={this.searchPoste}>
                                IR
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        let regions = [];
        let reg = "";
        let title = "Seleccione una opción";
        if (this.props.regions) {
            if (this.props.regions_array.length === 0) {
                for (let i = 0; i < this.props.regions.length; i++) {
                    if (this.props.regions[i].region !== reg) {
                        let c = "";
                        if (this.props.regions_array.indexOf(this.props.regions[i].region) >= 0) {
                            c = "active";
                        }

                        regions.push(
                            <li className={c} key={`region${i}`} onClick={() => this.props.addRegions(this.props.regions[i].region.trim())} tabIndex="0">
                                {this.props.regions[i].region.trim()}
                            </li>
                        );
                        reg = this.props.regions[i].region;
                    }
                }
                title = "Seleccione un Departamento";
            } else if (this.props.municipios_array.length === 0) {
                for (let i = 0; i < this.props.regions.length; i++) {
                    if (this.props.regions[i].municipio !== reg && this.props.regions_array.indexOf(this.props.regions[i].region) >= 0) {

                        regions.push(
                            <li key={`sregion${i}`} onClick={() => this.props.addMunicipios(this.props.regions[i].municipio.trim())} tabIndex="0">
                                {this.props.regions[i].municipio.trim()}
                            </li>
                        );
                        reg = this.props.regions[i].municipio;
                    }
                }
                title = "Seleccione un Municipio";
            } else {
                let regs = [...this.props.regions];
                // regs.sort(this.compare);
                regs.sort((a, b) => (parseInt(a.zona, 10) > parseInt(b.zona, 10)) ? 1 : -1)

                for (let i = 0; i < regs.length; i++) {
                    if (regs[i].zona !== null && regs[i].zona !== reg && this.props.municipios_array.indexOf(regs[i].municipio) >= 0) {
                        regions.push(
                            <li key={`zregion${i}`} onClick={() => this.props.addZonas(regs[i].zona.trim())} tabIndex="0">
                                {regs[i].zona.trim()}
                            </li>
                        );
                        reg = regs[i].zona;
                    }
                }
                title = "Seleccione una zona";
            }
        }

        //Modal Cobertura
        let modal = "";
        if (this.props.showRegions && regions.length > 0) {
            modal = (
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.showRegions}
                >
                    <div className="modal">
                        <h6 id="modal-title">
                            {title}
                        </h6>
                        <ul>
                            {regions}
                        </ul>
                        {/*<Button className="close-modal-button" onClick={this.props.toggleRegions}>Cerrar</Button>*/}
                    </div>
                </Modal>
            );
        }

        //We check if it's mobile
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        // Modal Inicial
        let modal_inicial = "";
        if (this.props.showInitialModal && !check && !this.props.showRegions) {
            modal_inicial = (
                <Modal
                    open={this.props.showInitialModal}
                    style={{ backgroundColor: 'rgba(3,62,110,0.5)' }}
                >
                    <div className="modal ubicacion">
                        <h6 id="modal-title">
                            Seleccione el método para encontrar una ubicación
                        </h6>
                        <div className="initial-modal-buttons">
                            <Button className="manual-button" onClick={() => { this.props.toggleRegions(); this.props.toggleInitialModal(); avoid = 1; }}>
                                Manual
                            </Button>
                            <Button variant="contained" className="gps-button" onClick={() => { this.props.getLocation(); this.props.toggleInitialModal(); avoid = 1; }}>
                                Ubicación <br />
                                Actual
                            </Button>
                        </div>
                    </div>
                </Modal>
            );
        }

        return (
            <React.Fragment>
                <div id="map"></div>
                {loading}
                {search}
                {searchNodo}
                {searchPoste}
                {modal}
                {modal_inicial}
                {searchCoordinates}
                {noEncontrado}
            </React.Fragment>

        );
    }
}
export default Mapa;


// WEBPACK FOOTER //
// ./src/components/Mapa.js